import { useState, useEffect, useRef } from "react";
import {
  ArrowLeft,
  Eye,
  Code2,
  Maximize2,
  Minimize2,
  Smartphone,
  Monitor,
  Type,
  Image,
  Minus,
  AlignLeft,
  Bold,
  Italic,
  Link2,
  List,
  Sparkles,
  Copy,
  Check,
} from "lucide-react";
import { showError, showSuccess } from "../lib/toast";
import {
  server_post_data,
  campaign_save_update,
  get_campaign_data,
} from "../serviceconnection/ServiceConnection";

// ─── Email Templates ──────────────────────────────────────────────────────────
const TEMPLATES = [
  {
    id: "newsletter",
    label: "Newsletter",
    html: `<div style="max-width:600px;margin:0 auto;font-family:sans-serif;background:#ffffff;">
  <div style="background:#1e293b;padding:32px 40px;text-align:center;">
    <h1 style="color:#ffffff;margin:0;font-size:24px;font-weight:700;">ThynkProcess</h1>
    <p style="color:#94a3b8;margin:8px 0 0;font-size:13px;">Monthly Insights</p>
  </div>
  <div style="padding:40px;">
    <h2 style="color:#1e293b;font-size:22px;margin:0 0 16px;">Hello there 👋</h2>
    <p style="color:#475569;line-height:1.7;margin:0 0 20px;">Welcome to this month's edition of ThynkProcess insights. Here's what we've been working on and what's new in the world of SAP and digital transformation.</p>
    <hr style="border:none;border-top:1px solid #e2e8f0;margin:28px 0;" />
    <h3 style="color:#1e293b;font-size:16px;margin:0 0 12px;">📌 Featured Article</h3>
    <p style="color:#475569;line-height:1.7;margin:0 0 20px;">Add your featured content here...</p>
    <a href="#" style="display:inline-block;background:#3b82f6;color:#ffffff;text-decoration:none;padding:12px 28px;border-radius:8px;font-weight:600;font-size:14px;">Read More →</a>
  </div>
  <div style="background:#f8fafc;padding:24px 40px;text-align:center;border-top:1px solid #e2e8f0;">
    <p style="color:#94a3b8;font-size:12px;margin:0;">© 2025 ThynkProcess Pty Ltd · 39/72 York Street, South Melbourne</p>
  </div>
</div>`,
  },
  {
    id: "announcement",
    label: "Announcement",
    html: `<div style="max-width:600px;margin:0 auto;font-family:sans-serif;background:#ffffff;">
  <div style="background:linear-gradient(135deg,#1e293b,#0f172a);padding:48px 40px;text-align:center;">
    <div style="display:inline-block;background:#3b82f6;color:#fff;font-size:11px;font-weight:700;letter-spacing:1px;padding:5px 14px;border-radius:20px;margin-bottom:16px;text-transform:uppercase;">Announcement</div>
    <h1 style="color:#ffffff;margin:0;font-size:28px;font-weight:800;line-height:1.3;">Your Announcement<br/>Title Here</h1>
  </div>
  <div style="padding:40px;">
    <p style="color:#475569;line-height:1.7;font-size:15px;margin:0 0 24px;">Write your announcement message here. Keep it clear and concise.</p>
    <div style="background:#eff6ff;border-left:4px solid #3b82f6;padding:16px 20px;border-radius:0 8px 8px 0;margin:0 0 28px;">
      <p style="color:#1e40af;margin:0;font-size:14px;font-weight:600;">Key highlight or important note goes here.</p>
    </div>
    <a href="#" style="display:inline-block;background:#3b82f6;color:#ffffff;text-decoration:none;padding:14px 32px;border-radius:8px;font-weight:700;font-size:14px;">Learn More</a>
  </div>
  <div style="background:#f8fafc;padding:24px 40px;text-align:center;border-top:1px solid #e2e8f0;">
    <p style="color:#94a3b8;font-size:12px;margin:0;">© 2025 ThynkProcess Pty Ltd</p>
  </div>
</div>`,
  },
  {
    id: "event",
    label: "Event Invite",
    html: `<div style="max-width:600px;margin:0 auto;font-family:sans-serif;background:#ffffff;">
  <div style="background:#1e293b;padding:32px 40px;text-align:center;">
    <p style="color:#3b82f6;font-size:12px;font-weight:700;letter-spacing:2px;text-transform:uppercase;margin:0 0 10px;">You're Invited</p>
    <h1 style="color:#ffffff;margin:0;font-size:26px;font-weight:800;">Webinar: SAP Business One<br/>Best Practices 2025</h1>
  </div>
  <div style="padding:40px;">
    <div style="display:flex;gap:20px;margin-bottom:28px;">
      <div style="flex:1;background:#f8fafc;border:1px solid #e2e8f0;border-radius:10px;padding:16px;text-align:center;">
        <p style="color:#94a3b8;font-size:11px;font-weight:700;text-transform:uppercase;margin:0 0 4px;">Date</p>
        <p style="color:#1e293b;font-weight:700;margin:0;">March 28, 2025</p>
      </div>
      <div style="flex:1;background:#f8fafc;border:1px solid #e2e8f0;border-radius:10px;padding:16px;text-align:center;">
        <p style="color:#94a3b8;font-size:11px;font-weight:700;text-transform:uppercase;margin:0 0 4px;">Time</p>
        <p style="color:#1e293b;font-weight:700;margin:0;">2:00 PM AEST</p>
      </div>
      <div style="flex:1;background:#f8fafc;border:1px solid #e2e8f0;border-radius:10px;padding:16px;text-align:center;">
        <p style="color:#94a3b8;font-size:11px;font-weight:700;text-transform:uppercase;margin:0 0 4px;">Duration</p>
        <p style="color:#1e293b;font-weight:700;margin:0;">60 min</p>
      </div>
    </div>
    <p style="color:#475569;line-height:1.7;margin:0 0 28px;">Join us for an insightful session on SAP Business One best practices. Our experts will walk you through real-world implementation tips and strategies.</p>
    <a href="#" style="display:inline-block;background:#3b82f6;color:#ffffff;text-decoration:none;padding:14px 36px;border-radius:8px;font-weight:700;font-size:14px;">Register Now →</a>
  </div>
  <div style="background:#f8fafc;padding:24px 40px;text-align:center;border-top:1px solid #e2e8f0;">
    <p style="color:#94a3b8;font-size:12px;margin:0;">© 2025 ThynkProcess Pty Ltd</p>
  </div>
</div>`,
  },
];

// ─── Snippet Blocks ───────────────────────────────────────────────────────────
const SNIPPETS = [
  {
    icon: <Type className="w-3.5 h-3.5" />,
    label: "Heading",
    html: `<h2 style="color:#1e293b;font-size:20px;font-weight:700;margin:0 0 12px;">Your Heading</h2>`,
  },
  {
    icon: <AlignLeft className="w-3.5 h-3.5" />,
    label: "Paragraph",
    html: `<p style="color:#475569;line-height:1.7;margin:0 0 16px;">Your paragraph text goes here.</p>`,
  },
  {
    icon: <Link2 className="w-3.5 h-3.5" />,
    label: "Button",
    html: `<a href="#" style="display:inline-block;background:#3b82f6;color:#fff;text-decoration:none;padding:12px 28px;border-radius:8px;font-weight:600;font-size:14px;margin:8px 0;">Button Text</a>`,
  },
  {
    icon: <Minus className="w-3.5 h-3.5" />,
    label: "Divider",
    html: `<hr style="border:none;border-top:1px solid #e2e8f0;margin:24px 0;" />`,
  },
  {
    icon: <List className="w-3.5 h-3.5" />,
    label: "List",
    html: `<ul style="color:#475569;line-height:1.9;padding-left:20px;margin:0 0 16px;">\n  <li>Item one</li>\n  <li>Item two</li>\n  <li>Item three</li>\n</ul>`,
  },
  {
    icon: <Image className="w-3.5 h-3.5" />,
    label: "Image",
    html: `<img src="https://via.placeholder.com/600x300" alt="Image" style="width:100%;border-radius:8px;display:block;margin:0 0 16px;" />`,
  },
];

const EMPTY_FORM = { p_id: 0, subject: "", body_html: "" };

export default function CampaignForm({ editId, onBack, onSaved }) {
  const [form, setForm] = useState(EMPTY_FORM);
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [viewMode, setViewMode] = useState("split"); // "split" | "code" | "preview"
  const [device, setDevice] = useState("desktop"); // "desktop" | "mobile"
  const [fullscreen, setFullscreen] = useState(false);
  const [copied, setCopied] = useState(false);
  const textareaRef = useRef(null);
  const previewRef = useRef(null);
  const isSyncingRef = useRef(false); // prevent infinite loop

  // ── Load draft ──────────────────────────────────────────────────────────
  useEffect(() => {
    if (!editId) return;
    (async () => {
      try {
        setFetching(true);
        const fd = new FormData();
        fd.append("main_id", editId);
        const res = await server_post_data(get_campaign_data, fd);
        const d = res.data?.message;
        if (!d) {
          showError("Campaign not found");
          return;
        }
        setForm({
          p_id: d.primary_id,
          subject: d.subject ?? "",
          body_html: d.body_html ?? "",
        });
      } catch {
        showError("Failed to load campaign");
      } finally {
        setFetching(false);
      }
    })();
  }, [editId]);

  const setField = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  // ── Sync: HTML → Preview (on form.body_html change) ─────────────────────
  useEffect(() => {
    const el = previewRef.current;
    if (!el || isSyncingRef.current) return;
    // Only update DOM if content actually differs — avoids cursor jump
    if (el.innerHTML !== form.body_html) {
      isSyncingRef.current = true;
      el.innerHTML = form.body_html;
      isSyncingRef.current = false;
    }
  }, [form.body_html]);

  // ── Sync: Preview (contentEditable) → HTML ───────────────────────────────
  const handlePreviewInput = () => {
    if (isSyncingRef.current) return;
    isSyncingRef.current = true;
    setField("body_html", previewRef.current?.innerHTML ?? "");
    isSyncingRef.current = false;
  };

  const insertSnippet = (html) => {
    const el = textareaRef.current;
    if (!el) {
      setField("body_html", form.body_html + "\n" + html);
      return;
    }
    const start = el.selectionStart;
    const end = el.selectionEnd;
    const next =
      form.body_html.slice(0, start) +
      "\n" +
      html +
      "\n" +
      form.body_html.slice(end);
    setField("body_html", next);
    setTimeout(() => {
      el.focus();
      el.setSelectionRange(start + html.length + 2, start + html.length + 2);
    }, 0);
  };

  // ── Apply template ───────────────────────────────────────────────────────
  const applyTemplate = (tpl) => {
    if (
      form.body_html.trim() &&
      !window.confirm("Replace current content with this template?")
    )
      return;
    setField("body_html", tpl.html);
  };

  // ── Copy HTML ────────────────────────────────────────────────────────────
  const copyHTML = () => {
    navigator.clipboard.writeText(form.body_html).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  // ── Save ─────────────────────────────────────────────────────────────────
  const handleSave = async () => {
    if (!form.subject.trim() || !form.body_html.trim()) {
      showError("Subject and body are required");
      return;
    }
    try {
      setLoading(true);
      const fd = new FormData();
      fd.append("p_id", form.p_id);
      fd.append("subject", form.subject);
      fd.append("body_html", form.body_html);
      const res = await server_post_data(campaign_save_update, fd);
      if (res.data?.error) {
        showError(res.data?.message || "Save failed");
        return;
      }
      showSuccess(form.p_id > 0 ? "Campaign updated!" : "Campaign created!");
      onSaved();
    } catch {
      showError("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // ── Loading ──────────────────────────────────────────────────────────────
  if (fetching) {
    return (
      <div className="max-w-[1200px] mx-auto space-y-5">
        <div className="flex items-center gap-3">
          <button
            onClick={onBack}
            className="w-8 h-8 rounded-lg flex items-center justify-center hover:bg-muted text-muted-foreground"
          >
            <ArrowLeft className="w-4 h-4" />
          </button>
          <h1 className="page-title">Loading...</h1>
        </div>
        <div className="section-panel p-10 text-center text-muted-foreground text-sm">
          Fetching campaign data...
        </div>
      </div>
    );
  }

  const wordCount = form.body_html
    .replace(/<[^>]*>/g, " ")
    .trim()
    .split(/\s+/)
    .filter(Boolean).length;

  return (
    <div
      className={`mx-auto space-y-4 ${fullscreen ? "fixed inset-0 z-50 bg-background p-5 overflow-y-auto" : "max-w-[1200px]"}`}
    >
      {/* ── Page Header ── */}
      <div className="page-header">
        <div className="flex items-center gap-3">
          <button
            onClick={onBack}
            className="w-9 h-9 rounded-lg flex items-center justify-center hover:bg-muted border border-border text-muted-foreground"
          >
            <ArrowLeft className="w-4 h-4" />
          </button>
          <div>
            <h1 className="page-title">
              {form.p_id > 0 ? "Edit Campaign" : "New Campaign"}
            </h1>
            <p className="page-subtitle">
              {form.p_id > 0
                ? `Editing: ${form.subject || "Untitled"}`
                : "Compose a new email campaign"}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={() => setFullscreen((f) => !f)}
            className="w-9 h-9 rounded-lg flex items-center justify-center hover:bg-muted border border-border text-muted-foreground"
            title={fullscreen ? "Exit fullscreen" : "Fullscreen"}
          >
            {fullscreen ? (
              <Minimize2 className="w-4 h-4" />
            ) : (
              <Maximize2 className="w-4 h-4" />
            )}
          </button>
          <button
            onClick={onBack}
            className="px-4 py-2 rounded-lg text-sm font-semibold border border-border text-foreground hover:bg-muted"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={loading}
            className="flex items-center gap-2 text-sm font-semibold px-4 py-2 rounded-lg text-white disabled:opacity-60"
            style={{ background: "hsl(var(--accent))" }}
          >
            {loading
              ? "Saving..."
              : form.p_id > 0
                ? "Update Draft"
                : "Save Draft"}
          </button>
        </div>
      </div>

      {/* ── Subject ── */}
      <div className="cms-card p-4">
        <div className="flex items-center gap-3">
          <label className="text-xs font-semibold text-muted-foreground whitespace-nowrap">
            Subject <span className="text-destructive">*</span>
          </label>
          <input
            value={form.subject}
            onChange={(e) => setField("subject", e.target.value)}
            placeholder="e.g. Our Latest Updates — March 2025"
            className="flex-1 px-3 py-2 rounded-lg border border-border bg-background text-sm text-foreground outline-none focus:border-accent"
          />
          <span className="text-xs text-muted-foreground whitespace-nowrap">
            {form.subject.length}/150
          </span>
        </div>
      </div>

      {/* ── Templates ── */}
      <div className="cms-card p-4">
        <div className="flex items-center gap-3 flex-wrap">
          <div className="flex items-center gap-1.5">
            <Sparkles
              className="w-3.5 h-3.5"
              style={{ color: "hsl(var(--accent))" }}
            />
            <span className="text-xs font-semibold text-muted-foreground">
              Templates:
            </span>
          </div>
          {TEMPLATES.map((t) => (
            <button
              key={t.id}
              onClick={() => applyTemplate(t)}
              className="px-3 py-1.5 rounded-lg text-xs font-semibold border border-border text-muted-foreground hover:border-accent/40 hover:text-foreground transition-colors"
            >
              {t.label}
            </button>
          ))}
          <div className="w-px h-4 bg-border mx-1" />
          <span className="text-xs font-semibold text-muted-foreground">
            Insert:
          </span>
          {SNIPPETS.map((s, i) => (
            <button
              key={i}
              onClick={() => insertSnippet(s.html)}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold border border-border text-muted-foreground hover:border-accent/40 hover:text-foreground transition-colors"
            >
              {s.icon} {s.label}
            </button>
          ))}
        </div>
      </div>

      {/* ── Editor ── */}
      <div className="section-panel p-0 overflow-hidden">
        {/* Toolbar */}
        <div className="flex items-center justify-between px-4 py-2.5 border-b border-border bg-muted/30">
          {/* View toggle */}
          <div className="flex items-center gap-1 p-1 rounded-lg bg-muted">
            {[
              {
                v: "code",
                icon: <Code2 className="w-3.5 h-3.5" />,
                label: "Code",
              },
              {
                v: "split",
                icon: <Monitor className="w-3.5 h-3.5" />,
                label: "Split",
              },
              {
                v: "preview",
                icon: <Eye className="w-3.5 h-3.5" />,
                label: "Preview",
              },
            ].map((m) => (
              <button
                key={m.v}
                onClick={() => setViewMode(m.v)}
                className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-semibold transition-all ${
                  viewMode === m.v
                    ? "bg-background text-foreground shadow-sm"
                    : "text-muted-foreground hover:text-foreground"
                }`}
              >
                {m.icon} {m.label}
              </button>
            ))}
          </div>

          <div className="flex items-center gap-2">
            {/* Device toggle — only in preview/split */}
            {viewMode !== "code" && (
              <div className="flex items-center gap-1 p-1 rounded-lg bg-muted">
                <button
                  onClick={() => setDevice("desktop")}
                  className={`p-1.5 rounded-md transition-all ${device === "desktop" ? "bg-background shadow-sm text-foreground" : "text-muted-foreground"}`}
                  title="Desktop"
                >
                  <Monitor className="w-3.5 h-3.5" />
                </button>
                <button
                  onClick={() => setDevice("mobile")}
                  className={`p-1.5 rounded-md transition-all ${device === "mobile" ? "bg-background shadow-sm text-foreground" : "text-muted-foreground"}`}
                  title="Mobile"
                >
                  <Smartphone className="w-3.5 h-3.5" />
                </button>
              </div>
            )}

            {/* Copy HTML */}
            <button
              onClick={copyHTML}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold border border-border text-muted-foreground hover:text-foreground transition-colors"
            >
              {copied ? (
                <>
                  <Check className="w-3.5 h-3.5 text-green-500" /> Copied
                </>
              ) : (
                <>
                  <Copy className="w-3.5 h-3.5" /> Copy HTML
                </>
              )}
            </button>

            {/* Stats */}
            <span className="text-xs text-muted-foreground hidden sm:block">
              {form.body_html.length} chars · {wordCount} words
            </span>
          </div>
        </div>

        {/* Editor body */}
        <div
          className={`${viewMode === "split" ? "grid grid-cols-2" : "block"}`}
          style={{ minHeight: 500 }}
        >
          {/* Code pane */}
          {viewMode !== "preview" && (
            <div
              className={`flex flex-col ${viewMode === "split" ? "border-r border-border" : ""}`}
            >
              <div className="px-3 py-1.5 border-b border-border bg-muted/20 flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-red-400/70" />
                <span className="w-2 h-2 rounded-full bg-yellow-400/70" />
                <span className="w-2 h-2 rounded-full bg-green-400/70" />
                <span className="text-xs text-muted-foreground ml-1">HTML</span>
              </div>
              <textarea
                ref={textareaRef}
                value={form.body_html}
                onChange={(e) => setField("body_html", e.target.value)}
                placeholder={
                  "<div>\n  <!-- Start writing your email -->\n</div>"
                }
                className="flex-1 p-4 text-sm font-mono bg-background text-foreground outline-none resize-none leading-relaxed"
                style={{ minHeight: 460, tabSize: 2 }}
                onKeyDown={(e) => {
                  if (e.key === "Tab") {
                    e.preventDefault();
                    const s = e.target.selectionStart;
                    const val = form.body_html;
                    setField(
                      "body_html",
                      val.slice(0, s) + "  " + val.slice(e.target.selectionEnd),
                    );
                    setTimeout(
                      () => e.target.setSelectionRange(s + 2, s + 2),
                      0,
                    );
                  }
                }}
              />
            </div>
          )}

          {/* Preview pane */}
          {viewMode !== "code" && (
            <div className="flex flex-col bg-muted/20">
              <div className="px-3 py-1.5 border-b border-border bg-muted/20 flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-red-400/70" />
                <span className="w-2 h-2 rounded-full bg-yellow-400/70" />
                <span className="w-2 h-2 rounded-full bg-green-400/70" />
                <span className="text-xs text-muted-foreground ml-1">
                  Preview — {device === "mobile" ? "375px" : "100%"}
                </span>
              </div>
              <div className="flex-1 overflow-auto p-4 flex justify-center">
                {form.body_html.trim() || true ? (
                  <div
                    ref={previewRef}
                    contentEditable
                    suppressContentEditableWarning
                    onInput={handlePreviewInput}
                    style={{
                      width: device === "mobile" ? 375 : "100%",
                      background: "#fff",
                      minHeight: 460,
                      outline: "none",
                    }}
                    className="rounded-lg overflow-hidden shadow-sm border border-border/50 text-sm focus-within:ring-2 focus-within:ring-accent/30 cursor-text"
                  />
                ) : (
                  <div className="flex flex-col items-center justify-center text-center py-20 text-muted-foreground">
                    <Eye className="w-10 h-10 mb-3 opacity-20" />
                    <p className="text-sm">
                      Start writing HTML to see the preview
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
